export const Config = {
  ACCESSIBILITY_URL:
    process.env.ACCESSIBILITY_URL ||
    "https://data.gov.il/api/3/action/datastore_search",
  CAR_DETAILS_URL:
    process.env.CAR_DETAILS_URL ||
    "https://www.gov.il/he/api/DataGovProxy/GetDGResults",
};
